module.exports = __webpack_public_path__ + "static/media/Window-boxIcon.f0da2e87.png";